var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordLabelBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7ZM13.5355 5.05022C13.9261 4.65969 14.5592 4.65969 14.9498 5.05022C15.3823 5.48278 15.7563 5.97018 16.0622 6.49996C16.3383 6.97826 16.1744 7.58985 15.6962 7.86599C15.2179 8.14213 14.6063 7.97826 14.3301 7.49996C14.1117 7.12155 13.8445 6.77341 13.5355 6.46443C13.145 6.07391 13.145 5.44074 13.5355 5.05022ZM5.66987 12.5C5.39373 12.0218 4.78214 11.8579 4.30385 12.134C3.82555 12.4102 3.66168 13.0218 3.93782 13.5C4.24369 14.0298 4.61769 14.5172 5.05025 14.9498C5.44078 15.3403 6.07394 15.3403 6.46447 14.9498C6.85499 14.5593 6.85499 13.9261 6.46447 13.5356C6.15549 13.2266 5.88835 12.8785 5.66987 12.5Z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordLabelBlack);
export default __webpack_public_path__ + "static/media/record-label-black.ff08b3ea3e92ba960e0ec97a4390a1e4.svg";
export { ForwardRef as ReactComponent };